import React from 'react';
import { withBasePath } from '../../constants/appPaths';
import { Alert, Box, Button, Typography } from '@mui/material';

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('App render error:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleResetAuth = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = withBasePath('/login');
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3, bgcolor: '#f8fafc' }}>
        <Box sx={{ maxWidth: 520, width: '100%' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            Something went wrong while loading this page.
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'monospace', fontSize: 12 }}>
            {this.state.error.message}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button variant="contained" onClick={this.handleReload}>Reload page</Button>
            <Button variant="outlined" onClick={this.handleResetAuth}>Clear session & sign in</Button>
          </Box>
        </Box>
      </Box>
    );
  }
}
